import { apiRequest } from '@/lib/api-client';
import {
  assertAnalyticsResponseScope,
  investorMetricWindowSchema,
  normalizeAnalyticsAddress,
  type InvestorMetricWindow
} from '@/lib/investor-analytics';
import {
  investorRiskMetricsResponseSchema,
  type InvestorRiskMetrics
} from '../types/api';

export async function fetchInvestorRiskMetrics(
  address: string,
  chainId: number,
  window?: InvestorMetricWindow,
  signal?: AbortSignal
): Promise<InvestorRiskMetrics> {
  const investor = normalizeAnalyticsAddress(address);
  const validatedWindow =
    window == null ? undefined : investorMetricWindowSchema.parse(window);

  const response = await apiRequest(
    `/api/v1/investor/${encodeURIComponent(investor)}/metrics`,
    investorRiskMetricsResponseSchema,
    {
      auth: 'required',
      chainId,
      query: { window: validatedWindow },
      signal
    }
  );

  assertAnalyticsResponseScope(investor, chainId, response);
  return response;
}
